import React, { useState } from "react";
import { Form, Container, Row, Col } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import "./UnifiedFormStyles.css";
import AppButton from "../../Components/MerchantButton";
import { compressAndUpload } from "../../Helpers/Utils/photoUpload";

function WastedTerminalSticker({ details, handleChange, navigation }) {

  const [errors, setErrors] = useState({});
  const [isUploading, setIsUploading] = useState(false);

  const handlePhotoChange = async (e, fieldName) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 5 * 1024 * 1024) {
      toast.error("Photo exceeds 5MB limit. Please retake the photo.", {
        autoClose: 3000, hideProgressBar: true, theme: "colored"
      });
      e.target.value = '';
      return;
    }

    setIsUploading(true);
    try {
      const uploadResult = await compressAndUpload(file);
      if (!uploadResult.success) {
        toast.error(uploadResult.error || "Upload failed. Please try again.");
        e.target.value = '';
        return;
      }
      handleChange({
        target: {
          name: `${fieldName}_temp_path`,
          value: uploadResult.temp_path,
          type: 'text'
        }
      });
    } catch (error) {
      toast.error("Error uploading photo");
    } finally {
      setIsUploading(false);
    }
  };

  const validate = () => {
    const newErrors = {
      sticker_wasted_count: !details.sticker_wasted_count,
      sticker_wasted_reason: !details.sticker_wasted_reason,
      wasted_photo: !details.wasted_photo_temp_path,
    };
    setErrors(newErrors);

    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleNext = () => {
    if (validate()) {
      navigation.go('thermal-roll');
    }
  };

  const handleBack = () => {
    navigation.previous();
  };


  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">

          {/* Main Form */}
          <Col md={10}>
              <div className="form-main-header">
                <h4 className="form-title">WASTED TERMINAL STICKER</h4>
                <p className="form-desc">Please provide the required information</p>
              </div>
               <div className="form-main">
              <div className="form-main-content">
                <Form>   
                  {/* Wasted terminal sticker count */}
                  <Form.Group className="mb-4" controlId="sticker_wasted_count">
                    <Form.Label className="form-label">
                      Wasted terminal sticker count <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="sticker_wasted_count"
                      value={details.sticker_wasted_count || ''}
                      onChange={handleChange}
                      placeholder="Enter count"
                      className={`form-input${errors.sticker_wasted_count ? " form-input-error" : ""}`}
                    />
                    {errors.sticker_wasted_count && (
                      <div className="form-error">
                        This field is required
                      </div>
                    )}
                  </Form.Group>

                  {/* Reason why sticker got wasted */}
                  <Form.Group className="mb-4" controlId="sticker_wasted_reason">
                    <Form.Label className="form-label">
                      Reason why sticker got wasted <span className="form-required">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      name="sticker_wasted_reason"
                      value={details.sticker_wasted_reason || ''}
                      onChange={handleChange}
                      rows={3}
                      placeholder="Enter reason..."
                      className={`form-textarea${errors.sticker_wasted_reason ? " form-input-error" : ""}`}
                    />
                    {errors.sticker_wasted_reason && (
                      <div className="form-error">
                        This field is required
                      </div>
                    )}
                  </Form.Group>

                  {/* Wasted terminal sticker photo */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">
                      Wasted terminal sticker photo <span className="form-required">*</span>
                      {details.wasted_photo_temp_path && !isUploading && (
                        <span style={{ marginLeft: '10px', color: '#28a745' }}>✅ Uploaded</span>
                      )}
                    </Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handlePhotoChange(e, 'wasted_photo')}
                      isInvalid={errors.wasted_photo}
                      disabled={isUploading}
                    />
                    {isUploading && <div style={{ color: '#007bff', fontSize: '13px', marginTop: '6px' }}>⏳ Uploading...</div>}
                    {errors.wasted_photo && (
                      <div className="form-error">Required</div>
                    )}
                  </Form.Group>

                  {/* Navigation Buttons */}
                  <div className="form-btn-row">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back 
                    </AppButton>
                    <AppButton
                      onClick={handleNext}
                      variant="next"
                      className="form-btn variant-primary"
                    >
                      Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default WastedTerminalSticker;
